/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DiscountChargesCorrections/view.blocks to change it.
import Location from './Location/index'
import React from 'react'
import SetupAction from './SetupAction/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DiscountChargesCorrections({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Onboarding/DiscountChargesCorrections"
  
}) {
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 text="Discounts, charges & Corrections"
/>
<div
  data-testid="DiscountChargesCorrections.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Location
  viewPath={`${viewPath}/Location`}
/>
<div
  data-testid="DiscountChargesCorrections.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<SetupAction
  viewPath={`${viewPath}/SetupAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}